<template>
	<BarLoader :color="'#343a40'" :width="240" :height="8" :loading="true" class="m-auto" />
</template>

<script>
	import { BarLoader } from '@saeris/vue-spinners';
	
	export default
	{
		name: 'Loader',
		components: { BarLoader },
		data () { return {} }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

